import { produce } from 'immer';
import ACTION_TYPE from '../../store/ACTION_TYPE';
import createReducerFunction from '../../store/reducerCreator';
import { parseAppDomainTokens } from '../../components/parseAppsDomainTokens';

interface Group {}
interface App {
    appId: string;
    status?: string;
    groups?: Group[];
}
interface State {
    app: App | null;
    isFetching: boolean;
    shouldUpdate: boolean;
}
interface Meta {
    pageDomain: string;
}
interface Action {
    type:
        | ACTION_TYPE.REQUEST_APP_PENDING
        | ACTION_TYPE.REQUEST_APP_FULFILLED
        | ACTION_TYPE.REQUEST_APPS_FULFILLED
        | ACTION_TYPE.APP_SETTINGS_CHANGED_FULFILLED
        | ACTION_TYPE.APP_SETTINGS_CHANGED_REJECTED
        | ACTION_TYPE.REUPLOAD_SIDELOADED_APP_FULFILLED;
    payload: any;
    meta?: Meta;
}

const initialState: State = {
    app: null,
    isFetching: false,
    shouldUpdate: false,
};

export default createReducerFunction<State, Action>({
    initialState,
    reducers: {
        [ACTION_TYPE.REQUEST_APP_PENDING]: (state) => ({ ...state, app: null, isFetching: true, shouldUpdate: false }),
        [ACTION_TYPE.REQUEST_APP_FULFILLED]: (state, { payload, meta }) => {
            const appsWithDomainUrls = parseAppDomainTokens(payload, meta?.pageDomain);

            return { ...state, app: appsWithDomainUrls || payload, isFetching: false, shouldUpdate: false };
        },
        [ACTION_TYPE.REQUEST_APP_REJECTED]: (state) => ({ ...state, isFetching: false, shouldUpdate: false }),
        [ACTION_TYPE.REQUEST_APPS_FULFILLED]: (state, { payload }) => {
            if (state.app && state.app.appId) {
                const app = payload.find((app: App) => app.appId === state?.app?.appId);
                if (!app) {
                    return state;
                }

                return produce(state, (draft) => {
                    if (draft.app) {
                        draft.app.groups = app.groups;
                    }
                });
            }

            return state;
        },
        [ACTION_TYPE.APP_SETTINGS_CHANGED_FULFILLED]: handleAppActionFullfilled,
        [ACTION_TYPE.APP_SETTINGS_CHANGED_REJECTED]: handleAppActionRejected,
        [ACTION_TYPE.REUPLOAD_SIDELOADED_APP_FULFILLED]: (state, { payload }) => {
            if (state.app && state.app.appId === payload.appId) {
                return produce(state, (draft) => {
                    if (draft.app) {
                        Object.assign(draft.app, payload);
                    }
                });
            }

            return state;
        },
    },
});

function handleAppActionFullfilled(state: State, { payload }: Action) {
    if (state.app && state.app.appId === payload.appId) {
        return produce(state, (draft) => {
            if (draft.app && payload.status) {
                draft.app.status = payload.status;
            }
        });
    }

    return state;
}

function handleAppActionRejected(state: State) {
    return { ...state, shouldUpdate: true };
}
